<!-- `for` pins the label's control to the text input. Without it the label targets its first
  labelable descendant - the first chip's edit <button> - so clicking blank space or a chip's
  remove icon would wrongly retarget onto that chip and open it for editing. -->
<label
  #field
  class="email-chips-input"
  [attr.for]="instanceId + '-input'"
  [class.email-chips-input--disabled]="disabled()"
  [class.email-chips-input--error]="hasError()"
  [class.email-chips-input--focus-ring]="showFocusRing()"
>
  <div class="email-chips-input__chips">
    @for (email of emails(); track email; let i = $index) {
      @if (editingIndex() === i) {
        <input
          #editInput
          class="email-chips-input__chip-edit"
          type="text"
          [attr.aria-label]="placeholder()"
          [value]="editValue()"
          [style.width.ch]="editValue().length + 1"
          (input)="onEditInput(editInput.value)"
          (keydown)="onEditKeydown($event, i)"
          (blur)="onEditBlur(i)"
          autocomplete="off"
        />
      } @else {
        <span class="email-chips-input__chip">
          <button
            type="button"
            class="email-chips-input__chip-label"
            [disabled]="disabled()"
            (click)="startEditingChip(i)"
          >
            {{ email }}
          </button>
          @if (!disabled()) {
            <button
              type="button"
              class="email-chips-input__chip-remove"
              [attr.aria-label]="'email-chips-input.remove-email' | translate: { email }"
              (click)="removeEmail(i)"
            >
              <ocp-themed-icon name="cross.svg" [size]="9" />
            </button>
          }
        </span>
      }
    }
    <input
      #emailInput
      [id]="instanceId + '-input'"
      class="email-chips-input__input"
      [class.ng-invalid-visible]="hasError()"
      type="text"
      [value]="inputValue()"
      (input)="onInput(emailInput.value)"
      (keydown)="onKeydown($event)"
      (blur)="onBlur()"
      (paste)="onPaste($event)"
      [disabled]="disabled()"
      [attr.placeholder]="emails().length === 0 ? placeholder() : ''"
      [attr.aria-label]="placeholder()"
      [attr.aria-describedby]="hasError() ? instanceId + '-error' : null"
      [attr.aria-invalid]="hasError() || null"
      autocomplete="off"
    />
  </div>
</label>
@if (hasError()) {
  <small [id]="instanceId + '-error'" class="email-chips-input__error">
    {{ 'form.errors.invalid-emails' | translate }}
  </small>
}
